import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IImportUsersCsvClient,
} from 'interfaceAdapter/gatewaySchemas/IImportUsersCsvClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/import/invite_users_csv`;

export class ImportUsersCsvClient implements IImportUsersCsvClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, csv_file, invitation_type } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        // FormDataを作成
        const formData = new FormData();
        formData.append('csv_file', csv_file);
        formData.append('invitation_type', invitation_type);

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body: formData,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
